import { AlternativeReadModel } from '@Alternatives/Alternatives/Domain/readmodels';
import AlternativesListsQueries from '@Alternatives/AlternativesLists/Domain/queries-vue-component';
import { AllRelationshipsReadModel } from '@Alternatives/AlternativesLists/Domain/readmodels';
import { strCompareLowerCase } from '@common/Common';
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { dynamicUiRoutes } from '@common/dynamicUiRoutes';
import { Component, mixins } from 'vue-facing-decorator';


@Component({
    components: {
        PortfolioOrDecisionNavigation
    }
})
export default class RelationshipsPage extends mixins(AlternativesListsQueries)
{
    get workspaceId(): number { return Number(this.$route?.params?.workspaceId ?? 0); }
    get projectId(): number { return Number(this.$route?.params?.projectId ?? 0); }

    url_AlternativeDashboardPage(alternativeId: string): string
    {
        return dynamicUiRoutes.Alternatives_AlternativeDashboardPage(this.$route, this.workspaceId, this.projectId, alternativeId);
    }

    rm: AllRelationshipsReadModel = null;

    AlternativesListId: number;
    Filter: string = 'All';
    ViewBy: string = 'Foundation';

    get FoundationsView() 
    {
        let view = this.rm.Alternatives.filter(a => a.DependentsIds.length > 0);

        if (this.Filter === 'Issues')
        {
            view = view.filter(a => this.getDependents(a).some(b => b.StatusId !== a.StatusId));
        }

        return view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));
    }

    get DependentsView() 
    {
        let view = this.rm.Alternatives.filter(a => a.FoundationsIds.length > 0);

        if (this.Filter === 'Issues')
        {
            view = view.filter(a => this.getFoundations(a).some(b => b.StatusId !== a.StatusId));
        }

        return view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));
    }


    getDependents(rm: AlternativeReadModel) { return this.rm.Alternatives.filter(a => rm.DependentsIds.includes(a.AlternativeId)); }

    getFoundations(rm: AlternativeReadModel) { return this.rm.Alternatives.filter(a => rm.FoundationsIds.includes(a.AlternativeId)); }


    toggleViewBy()
    {
        if (this.ViewBy === 'Foundation')
        {
            this.ViewBy = 'Dependent';
        }
        else
        {
            this.ViewBy = 'Foundation';
        }
    }

    toggleFilter()
    {
        if (this.Filter === 'All')
        {
            this.Filter = 'Issues';
        }
        else
        {
            this.Filter = 'All';
        }
    }


    mounted()
    {
        document.title = "Dependencies | TransparentChoice";
        this.runRelationshipsByProjectIdQueryV1(this.workspaceId, this.projectId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "AllRelationshipsReadModel")
        {
            this.rm = model as AllRelationshipsReadModel;
        }
    }
}